import React, { useContext, useEffect, useState } from "react";
import { useCookies } from "react-cookie";
import Select from "react-select";
import globalContext from "../../Contexts/GlobalContext";

import "./AreaSelect.css";
import { SERVERMODE } from "../../constants/serverMode";
import { handleServerMode } from "../../utils/handleServer";
import { useNavigate } from "react-router-dom";
import { AREA } from "../../constants/areas";

export default function AreaSelect({ area, setArea }) {
  const customStyles = {
    control: (base, state) => ({
      ...base,
      background: `#00333C`,
      color: "#FFF",
      border: state.isFocused ? 1 : 1,
      boxShadow: "none",
      border: `1px solid #00F7FF`,
      minHeight: "21px",
      height: "10vw",
      fontFamily: "brandsFont",
      textAlighn: "left",
      fontSize: "3.5vw",
      padding: "0px 0px 0px 8px",
    }),

    option: (base) => ({
      ...base,
      color: "#FFF",
      border: "none",
      background: "transparent",
      fontFamily: "brandsFont",
      textAlighn: "left",
    }),
    singleValue: (base) => ({
      ...base,
      color: `#FFF`,
      border: "none",
      fontFamily: "brandsFont",
      textAlighn: "left",
    }),
    menu: (base) => ({
      ...base,
      borderRadius: 0,
      marginTop: 0,
      background: "#2F3335",
      zIndex: 9999,
    }),
    menuList: (base) => ({
      ...base,
      padding: 0,
      background: "#2F3335",
      "::-webkit-scrollbar": {
        width: "9px",
      },
      "::-webkit-scrollbar-track": {
        background: "#555",
      },
      "::-webkit-scrollbar-thumb": {
        background: "#00F7FF",
      },
      "::-webkit-scrollbar-thumb:hover": {
        background: "#555",
      },
    }),
    valueContainer: (provided, state) => ({
      ...provided,
      height: "10vw",
      padding: "0 0",
    }),
    indicatorsContainer: (provided, state) => ({
      ...provided,
      height: "10vw",
      fontSize: "180px",
      color: "red",
    }),
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
  };
  return (
    <Select
      styles={customStyles}
      options={AREA}
      value={area}
      isSearchable={true}
      menuPortalTarget={document.body}
      placeholder={<p className="font-font_primary_A">انتخاب نمایید</p>}
      onChange={(e) => {
        setArea(e);
      }}
    />
  );
}
